import { Modelo } from '@ext/index';
import * as Types from './Preset.types';
import moment, { Moment } from 'moment';

export class IPreset extends Modelo
{

    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Id: number = 0;
    public Nombre: string = '';
    public Descripcion: string = '';
    public Color: string = '';
    public Columnas: IColumna[] = [];


    public getJson(): any
    {
        let json: any = {};

        json.nombre = this.Nombre;
        json.descripcion = this.Descripcion;
        json.color = this.Color;
        json.columnas = this.Columnas.map( x => x.getJson() );

        return json;
    }


    public set(): boolean
    {

        this.Id = !this.Json.id ? 0 : this.Json.id;
        this.Nombre = !this.Json.nombre ? '' : this.Json.nombre;
        this.Descripcion = !this.Json.descripcion ? '' : this.Json.descripcion;
        this.Color = !this.Json.color ? '' : this.Json.color;
        this.Columnas = this.Json.columnas.map( ( x: any ) => new IColumna( x ) );

        this.Existe = true;
        return this.Existe;
    }


}

export class IColumna extends Modelo
{

    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Preset: number = 0;
    public Columna: number = -1;
    public Tipo: string = '';


    public getJson(): any
    {
        let json: any = {};
        json.columna = this.Columna;
        json.tipo = this.Tipo;
        return json;
    }


    public set(): boolean
    {

        this.Preset = !this.Json.preset ? 0 : this.Json.preset;
        this.Columna = this.Json.columna;
        this.Tipo = this.Json.tipo;

        this.Existe = true;
        return this.Existe;
    }

}